import * as React from 'react';

import AppState from '@webapp/store/state';
import { connect } from 'react-redux';

import ButtonFixed from '@components/layout/button-fixed';
import ButtonLoadingCtrl from '@webapp/controllers/button-loading';

interface StepButtonProps {
  id?: string;
  className?: string;
  isValid?: boolean;
  label?: React.ReactNode;
  isLoading?: boolean;
  disableLoader?: boolean;
  onNext: () => void;
  isMobile: boolean;
  locked?: boolean;
  hasLoader?: boolean;
  fixed?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const StepButton: React.FC<StepButtonProps> = (props) => {
  const getLabel = () => {
    if (props.label) {
      return props.label;
    }

    return 'Next Step';
  };

  return (
    <ButtonFixed
      className={props.className}
      fixed={props.fixed === undefined ? true : props.fixed}
    >
      <ButtonLoadingCtrl
        id={props.id}
        disabled={!props.isValid}
        uppercase={props.isMobile}
        isLoading={!!props.isLoading}
        locked={props.locked}
        hasLoader={props.hasLoader === undefined ? true : props.hasLoader}
        disableLoader={props.disableLoader}
        onClick={() => props.onNext()}
      >
        {!props.isValid && props.isMobile
          ? 'Please fill all of the fields'
          : getLabel()}
      </ButtonLoadingCtrl>
    </ButtonFixed>
  );
};

export default connect(mapStateToProps)(StepButton);
